'use client';
import { useEffect, useRef } from 'react';
import useAccount from '@/lib/hooks/useAccount';
import { USER_TRACKING_ID } from '@/constants/localStorage';
import { pushUid, removeUidFromDataLayer, storeAndPushUid } from '@/utils/userTracking';

const useUserTracking = () => {
  const { account, loggedIn, isLoading } = useAccount();
  const pushed = useRef(false);
  const wasLoggedIn = useRef(false);

  useEffect(() => {
    if (isLoading) return;

    // Logout detected — clear identity
    if (wasLoggedIn.current && !loggedIn) {
      removeUidFromDataLayer();
      localStorage.removeItem(USER_TRACKING_ID);
      pushed.current = false;
      wasLoggedIn.current = false;
      return;
    }

    if (pushed.current) return;

    if (loggedIn && account?.accountId) {
      storeAndPushUid(account.accountId);
      pushed.current = true;
      wasLoggedIn.current = true;
    } else if (!loggedIn) {
      const stored = localStorage.getItem(USER_TRACKING_ID);
      if (stored) {
        pushUid(stored);
        pushed.current = true;
      }
    }
  }, [isLoading, loggedIn, account?.accountId]);
};

export default useUserTracking;
